"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
var types_1 = require("./types");
function reducer(state, action) {
    if (action.type === types_1.LineOfCoverageEditorActionType.ADD_SELECTED_LOC) {
        var selectedLineOfCoverageTypeDetails = state.selectedLineOfCoverageTypeDetails;
        var lineOfCoverage = action.payload.lineOfCoverage;
        return __assign(__assign({}, state), { selectedLineOfCoverageTypeDetails: __spreadArray([lineOfCoverage], selectedLineOfCoverageTypeDetails) });
    }
    if (action.type === types_1.LineOfCoverageEditorActionType.REMOVE_SELECTED_LOC) {
        var selectedLineOfCoverageTypeDetails = state.selectedLineOfCoverageTypeDetails;
        var _a = action.payload, index = _a.index, isDeleting = _a.isDeleting;
        return __assign(__assign({}, state), { selectedLineOfCoverageTypeDetails: removeAtIndex(selectedLineOfCoverageTypeDetails, index), 
            // if state isDeleting is already `true`, keep it true
            isDeletingCoverage: state.isDeletingCoverage || isDeleting });
    }
    if (action.type === types_1.LineOfCoverageEditorActionType.UPDATE_DISPLAY_NAME) {
        var selectedLineOfCoverageTypeDetails = state.selectedLineOfCoverageTypeDetails;
        var _b = action.payload, displayName_1 = _b.displayName, index = _b.index;
        return __assign(__assign({}, state), { selectedLineOfCoverageTypeDetails: updateAtIndex(selectedLineOfCoverageTypeDetails, index, function () { return ({
                displayName: displayName_1,
            }); }) });
    }
    return state;
}
exports.reducer = reducer;
function updateAtIndex(group, index, updateFn) {
    var item = group[index];
    return replaceAtIndex(group, index, __assign(__assign({}, item), updateFn(item)));
}
function replaceAtIndex(group, index, updated) {
    var newList = group.slice();
    newList.splice(index, 1, updated);
    return newList;
}
function removeAtIndex(group, index) {
    var newList = group.slice();
    newList.splice(index, 1);
    return newList;
}
